const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	}, {
		prop: "StatusName",
		label: "状态",
		columnwidth: 80,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "InvNames",
		label: "产品名称",
		columnwidth: 220,
	},
	{
		prop: "HospitalName",
		label: "医院",
		columnwidth: 180,
	},
	{
		prop: "ProvinceName",
		label: "省份",
		columnwidth: 100,
	},
	{
		prop: "CityName",
		label: "城市",
		columnwidth: 100,
	},
	{
		prop: "TechnicalOffices",
		label: "科室",
		columnwidth: 100,
	},
	{
		prop: "Dispatcher",
		label: "配送商",
		columnwidth: 100,
	},
	{
		prop: "DispatcherTypeName",
		label: "配送商类型",
		columnwidth: 100,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 200,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 180,
	},
	{
		prop: "DispatchRemark",
		label: "配送备注",
		columnwidth: 100,
	},
	{
		prop: "ChannelRemark",
		label: "渠道备注",
		columnwidth: 150,
	},
	{
		prop: "SubmitterName",
		label: "提交人",
		columnwidth: 150,
	},
	{
		prop: "SubmitTime",
		label: "提交时间",
		columnwidth: 180,
	},
	{
		prop: "ApproverName",
		label: "审核人",
		columnwidth: 150,
	},
	{
		prop: "RejecterName",
		label: "驳回人",
		columnwidth: 150,
	},
	{
		prop: "RejectReason",
		label: "驳回原因",
		columnwidth: 150,
	},
	{
		prop: "RevokeReason",
		label: "撤回原因",
		columnwidth: 150,
	},
	{
		prop: "RevokeTime",
		label: "撤回时间",
		columnwidth: 180,
	}
];
export default headerData;